import {
  List,
  Datagrid,
  TextField,
  ChipField,
  ReferenceField,
  DateField,
  NumberField,
  SearchInput,
  SelectInput,
  ReferenceInput,
  TextInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const InterceptList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <SelectInput
        source="cipherType"
        choices={[
          { id: 'caesar', name: 'caesar' },
          { id: 'vigenere', name: 'vigenere' },
          { id: 'playfair', name: 'playfair' },
          { id: 'enigma', name: 'enigma' },
          { id: 'railfence', name: 'railfence' },
        ]}
      />,
      <ReferenceInput source="creatorId" reference="users" />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <TextField source="code" />
      <ChipField source="cipherType" />
      <TextField source="ciphertext" />
      <TextField source="publicParams" />
      <TextField source="verifier" />
      <TextField source="provenance" />
      <ReferenceField source="creatorId" reference="users" />
      <DateField source="expiresAt" />
      <NumberField source="views" />
      <NumberField source="cracks" />
      <NumberField source="bestMs" />
    </Datagrid>
  </List>
)

export const InterceptShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="code" />
      <ChipField source="cipherType" />
      <TextField source="ciphertext" />
      <TextField source="publicParams" />
      <TextField source="verifier" />
      <TextField source="provenance" />
      <ReferenceField source="creatorId" reference="creators" />
      <DateField source="expiresAt" />
      <NumberField source="views" />
      <NumberField source="cracks" />
      <NumberField source="bestMs" />
    </SimpleShowLayout>
  </Show>
)
